import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { EnhancedConsentPlugin } from '@snowplow/browser-plugin-enhanced-consent';
import { OptimizelyXPlugin } from '@snowplow/browser-plugin-optimizely-x';

import { CardService, DynamicElementService } from '@sirius/common';

import {
    ActivityTrackingConfiguration,
    enableActivityTracking,
    newTracker,
    TrackerConfiguration,
} from '@snowplow/browser-tracker';
import {
    CardContentComponent,
    CardOverviewCommerceComponent,
    CardProductCommerceComponent,
    FileDownloadListComponent,
    MarketplaceSearchComponent,
    PartnerPageComponent,
    ProductHeaderCommerceWrapperComponent,
} from 'commerce';
import { WidgetComponent } from 'widget';
import { RobotSelectorComponent } from 'robot-selector';
import { CardEventComponent } from 'event-management';
import { MatchmakingComponent } from 'matchmaking';
import {
    CountdownComponent,
    CtaSideBySideComponent,
    CustomerSuccessPanelComponent,
    EventPageHeroHeaderComponent,
    FeaturedLinksSideNavComponent,
    InfoOverviewComponent,
    LogoCarouselComponent,
    ProductSpecificationsComponent,
    ProductSliderComponent,
} from 'shared';
import { environment } from '../environments';
import { PageComponent } from './components/page/page.component';

@Component({
    selector: 'butterfly-app',
    template: `<butterfly-page></butterfly-page>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageComponent],
})
export class AppComponent implements OnInit {
    private _cardService = inject(CardService);
    private _dynamicComponentService = inject(DynamicElementService);

    private _trackerCfg: TrackerConfiguration;
    private _activityCfg: ActivityTrackingConfiguration;

    constructor() {
        this._cardService.addCards([
            {
                'commerce': CardProductCommerceComponent,
                'card-content': CardContentComponent,
                'event': CardEventComponent,
            },
        ]);

        this._dynamicComponentService.addComponents([
            { 'commerce-card-overview-component': CardOverviewCommerceComponent },
            { 'product-commerce-header': ProductHeaderCommerceWrapperComponent },
            { 'commerce-file-download-list': FileDownloadListComponent },
            { 'matchmaking-form': MatchmakingComponent },
            { 'marketplace-search': MarketplaceSearchComponent },
            { 'product-specifications': ProductSpecificationsComponent },
            { 'product-slider': ProductSliderComponent },
            { 'commerce-partner-page': PartnerPageComponent },
            { 'time-range': CountdownComponent },
            { 'info-overview': InfoOverviewComponent },
            { 'customer-success-panel': CustomerSuccessPanelComponent },
            { 'logo-carousel': LogoCarouselComponent },
            { 'featured-links-side-nav': FeaturedLinksSideNavComponent },
            { 'cta-side-by-side': CtaSideBySideComponent },
            { 'hero-small-event-page': EventPageHeroHeaderComponent },
            { widget: WidgetComponent },
            { 'robot-selector': RobotSelectorComponent },
        ]);

        this._trackerCfg = {
            appId: 'storyblok-corporate-website',
            discoverRootDomain: true,
            cookieSameSite: 'Lax',
            plugins: [EnhancedConsentPlugin(), OptimizelyXPlugin()],
        };

        this._activityCfg = {
            minimumVisitLength: 10,
            heartbeatDelay: 20,
        };
    }

    ngOnInit() {
        newTracker('corporate-tracker', environment.snowplow.defaultEndpoint, this._trackerCfg);
        enableActivityTracking(this._activityCfg);
    }
}
